import { kvRows } from "./PDFKeyValue";

/**
 * Bloque de equipo médico (doctor / paciente / cirugía).

 * @param {object} params
 * @param {object} params.values
 * @param {object} params.empresa
 * @returns Array de nodos pdfMake
 */
export const PDFEquipoMedicoV2 = ({ values = {}, empresa = {} } = {}) => {
  if (
    !(
      (values.doctor || values.paciente) &&
      empresa?._id?.toString() !== "6794158fb43c29469460b824"
    )
  ) {
    return [];
  }

  const left = [
    { label: "Nombre del doctor:", value: values?.doctor?.nombre ? values.doctor.nombre : "" },
  ];
  const right = [
    { label: "Nombre del paciente:", value: values?.paciente?.nombre ? values.paciente.nombre : "" },
    {
      label: "Cirugía:",
      value: values?.cirugia?.nombre
        ? values.cirugia.nombre
        : values?.paciente?.cirugia
          ? values.paciente.cirugia
          : "",
    },
  ];

  return [
    {
      margin: [0, 0, 0, 8], 
      columns: [
        {
          width: "50%",
          stack: kvRows(left, { labelWidth: "42%" }),  
        },
        {
          width: "50%",
          stack: kvRows(right, { labelWidth: "32%" }), 
        },
      ],
      columnGap: 24,
    },
  ];
};

export default PDFEquipoMedicoV2;